import { Modal } from 'antd';

const ModalAction = (props) => {
  return <Modal {...props} />;
};

export default ModalAction;
